import { RotasEnum } from "@/utils/rotas";
import { BarcodeIcon, FlaskConicalIcon, GaugeIcon, ShapesIcon, SproutIcon, TagsIcon, UsersIcon } from "lucide-react";
import moment from "moment";
import { ElementType } from "react";

type MenuItem = {
    title: string;
    url: string;
    icone: ElementType;
}



export const MenuItems: MenuItem[] = [
    {
        title: 'Home',
        icone: GaugeIcon,
        url: RotasEnum.PAINEL,
    },
    {
        title: 'Usuários',
        icone: UsersIcon,
        url: RotasEnum.USUARIOS
    },
    {
        title: 'Produtos',
        icone: BarcodeIcon,
        url: RotasEnum.PRODUTOS,
    },
    {
        title: 'Classificação',
        icone: ShapesIcon,
        url: RotasEnum.CLASSIFICACOES
    },
    {
        title: 'Nutrientes',
        icone: FlaskConicalIcon,
        url: RotasEnum.NUTRIENTES
    },
    {
        title: 'Tipos de culturas',
        icone: SproutIcon,
        url: RotasEnum.TIPOS_DE_CULTURA
    },
    {
        title: 'Tipos de documentos',
        icone: TagsIcon,
        url: RotasEnum.TIPOS_DE_DOCUMENTOS
    },
]


moment.locale('pt-br');


moment.updateLocale('pt-br', {
    months : [
        "Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho",
        "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"
    ],
    monthsShort : [
        "Jan", "Fev", "Mar", "Abr", "Mai", "Jun", "Jul",
        "Ago", "Set", "Out", "Nov", "Dez"
    ],
    weekdays : [
        "Domingo", "Segunda", "Terça", "Quarta", "Quinta", "Sexta", "Sábado"
    ],
    weekdaysShort : [
        "Dom", "Seg", "Ter", "Qua","Qui", "sex", "Sab"
    ],
    weekdaysMin : [
        "D", "S", "T", "Q", "Q", "S", "S"
    ],
    longDateFormat : {
        LT : "HH:mm",
        LTS : "HH:mm:ss",
        L : "DD/MM/YYYY",
        LL : "D [de] MMMM [de] YYYY",
        LLL : "D [de] MMMM [de] YYYY [às] HH:mm",
        LLLL : "dddd, D [de] MMMM [de] YYYY [às] HH:mm"
    },
    calendar : {
        sameDay: '[Hoje às] LT',
        nextDay: '[Amanhã às] LT',
        nextWeek: 'dddd [às] LT',
        lastDay: '[Ontem às] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : "em %s",
        past : "%s atrás",
        s : "poucos segundos",
        ss : "%d segundos",
        m : "um minuto",
        mm : "%d minutos",
        h : "uma hora",
        hh : "%d horas",
        d : "um dia",
        dd : "%d dias",
        M : "um mês",
        MM : "%d meses",
        y : "um ano",
        yy : "%d anos"
    },
    dayOfMonthOrdinalParse: /\d{1,2}º/,
});



export const UNIDADES_MEDIDA = [
    {
        label: "%",
        value: "%",
    },
    {
        label: "g/L",
        value: "g/L",
    },
    {
        label: "g/g",
        value: "g/g",
    },
    {
        label: "ppm",
        value: "ppm",
    },
    {
        label: "kg/g",
        value: "kg/g",
    },
    {
        label: "L/L",
        value: "L/L",
    },
    {
        label: "mL/L",
        value: "mL/L",
    },
    {
        label: "g/kg",
        value: "g/kg",
    },
    {
        label: "L/ha",
        value: "L/ha",
    },
    {
        label: "mL/ha",
        value: "mL/ha",
    },
    {
        label: "Kg/ha",
        value: "Kg/ha",
    },
    {
        label: "mL/kg",
        value: "mL/kg",
    }
]



export const ESTADOS = [
    { id: "AC", nome: "Acre", coordenadas: [-73.2, -7.2] },
    { id: "AL", nome: "Alagoas", coordenadas: [-37.8, -8.2] },
    { id: "AP", nome: "Amapá", coordenadas: [-54.5, 3.0] },
    { id: "AM", nome: "Amazonas", coordenadas: [-67.0, -2.5] },
    { id: "SP", nome: "São Paulo", coordenadas: [-51.63, -20.55] },
    { id: "RJ", nome: "Rio de Janeiro", coordenadas: [-45.17, -21.91] },
    { id: "BA", nome: "Bahia", coordenadas: [-44.5, -10.97] },
    { id: "CE", nome: "Ceará", coordenadas: [-42.5, -3.5] },
    { id: "DF", nome: "Distrito Federal", coordenadas: [-50.9292, -12.7801] },
    { id: "ES", nome: "Espírito Santo", coordenadas: [-41.8, -18.3155] },
    { id: "GO", nome: "Goiás", coordenadas: [-53.25, -14.64] },
    { id: "MA", nome: "Maranhão", coordenadas: [-48.3, -3.25] },
    { id: "MT", nome: "Mato Grosso", coordenadas: [-58.7, -11.64] },
    { id: "MS", nome: "Mato Grosso do Sul", coordenadas: [-57.84, -18.51] },
    { id: "MG", nome: "Minas Gerais", coordenadas: [-47.58, -16.92] },
    { id: "PA", nome: "Pará", coordenadas: [-55.29, -2.45] },
    { id: "PB", nome: "Paraíba", coordenadas: [-36.85, -5.12] },
    { id: "PR", nome: "Paraná", coordenadas: [-54.58, -22.80] },
    { id: "PE", nome: "Pernambuco", coordenadas: [-37.0, -6.8] },
    { id: "PI", nome: "Piauí", coordenadas: [-44.8, -5.50] },
    { id: "RN", nome: "Rio Grande do Norte", coordenadas: [-39.0, -2.5] },
    { id: "RS", nome: "Rio Grande do Sul", coordenadas: [-56.22, -28.03] },
    { id: "RO", nome: "Rondônia", coordenadas: [-65.9, -8.82] },
    { id: "RR", nome: "Roraima", coordenadas: [-64.0, 3.82] },
    { id: "SC", nome: "Santa Catarina", coordenadas: [-53, -25.33] },
    { id: "SE", nome: "Sergipe", coordenadas: [-39.3, -9.91] },
    { id: "TO", nome: "Tocantins", coordenadas: [-51.25, -8.25] }
];

export const BASE_URL = import.meta.env.VITE_BACKEND_URL ?? 'http://localhost:8080/api/v1';
